import classes from "./SharePrivacy.module.css";
import { AccessSelector } from "./AccessSelector";
import { ShareInput } from "../ShareInput/ShareInput";
import { ACCESS_ANYONE } from "../shareConstants";

/**
 * The "General access" section: what the link itself grants, and the link.
 * Presentation only; the actions that commit a change live in the dialog footer.
 */
export const SharePrivacy = ({ privacy, setPrivacy }) => (
  <div className={classes.generalAccess}>
    <p className={classes.sectionLabel}>General access</p>

    <AccessSelector type={privacy} setType={setPrivacy} />

    {/* Only while the link is what grants access: a restricted map opens for
        nobody who was not added, so the link would promise access it lacks. */}
    {privacy === ACCESS_ANYONE && <ShareInput />}
  </div>
);
